import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Container = styled(View, theme => {
  return {
    base: {
      paddingLeft: theme.paddingInsetOnepulse,
      paddingRight: theme.paddingInsetOnepulse,
    },
    variants: {},
  }
})
